import { Injectable, Injector } from '@angular/core';
import { AppComponentBase } from '@shared/common/app-component-base';
import { LegitimationServiceProxy } from '@shared/service-proxies/service-proxies';

@Injectable({ providedIn: 'root' })
export class LegitimationService extends AppComponentBase {
    constructor(
        injector: Injector,
        private legitimationService: LegitimationServiceProxy
    ) {
        super(injector);
    }

    getLegitimationForPerson(id: number) {
        return this.legitimationService.getLegitimationForPerson(id).pipe();
    }

    getLegitimationForSponsorship(id: number) {
        return this.legitimationService.getLegitimationForSponsorship(id).pipe();
    }
}
